import { matchPath } from 'react-router-dom';

/**
 * Routes où AppLayout doit clamper la hauteur au viewport (h-screen + overflow-hidden)
 * au lieu du scroll de document par défaut (min-h-screen) — pour que leur propre chaîne
 * de scroll interne (canvas + drawer) puisse enfin se déclencher.
 * cf. context/specs/2026-08-06-report-builder-viewport-fixe.md
 */
const FIXED_VIEWPORT_PATTERNS = ['/p/:projectId/reports/:reportId'];

export function isFixedViewportRoute(pathname: string): boolean {
  return FIXED_VIEWPORT_PATTERNS.some(
    (pattern) => matchPath({ path: pattern, end: true }, pathname) !== null,
  );
}
